<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link
          :to="localePath('local-information')"
          class="breadcrumb  px-2"
        >
          {{ $t('LOCAL_INFORMATION') }}</nuxt-link
        >
      </div>
    </div>
    <div class="xl:h-screen flex flex-col justify-center ">
      <div class="container mx-auto text-center py-12 xl:py-24 px-4 ">
        <h4 class="font-semibold text-3xl mb-1">{{ $t('find_local') }}</h4>
        <p class="text-gray-600 mb-6">{{ $t('local_information_info2') }}</p>
        <div class="market-buttons grid grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 gap-4 justify-center mt-6">
  <nuxt-link
    v-for="market in markets"
    :key="market.slug"
    v-scroll-reveal
    :to="`${languagePrefix}/local-information/${market.slug}`"
    class="market uppercase text-black border border-transparent hover:border-gray-500 flex items-center justify-center px-5 py-3"
  >
            <!-- bila bi fora dodati auto find  -->
            <img :src="'/img/icons/' + market.slug + '.png'" class="w-11"
            :alt="market.slug + ' image'"
            />
            <span> {{ market.name[lang] }} </span>
          </nuxt-link>
          <div
            @click="locateMarket"
            class="invisible cursor-pointer market w-1/2 md:w-1/5 w-20 px-6 uppercase  mt-6 text-black flex border border-transparent items-center justify-around px-5 py-3 mr-5"
          >
            <span class="text-white">COMING SOON</span>
          </div>
        </div>
      </div>
      <div class="text-center my-6 pb-4">
        <h4 class="font-bold text-2xl ">
          {{ $t('anything_you_need_help') }}
        </h4>
        <div class="flex flex-wrap justify-center">
          <nuxt-link
            :to="localePath('solutions')"
            class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
            >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
          >
          <nuxt-link
            :to="localePath('contact')"
            class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
            >{{ $t('contact') }}</nuxt-link
          >
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import markets from '~/static/markets.json'
export default {
  data() {
    return {
      markets
    }
  },
  computed: {
    languagePrefix() {
      return this.$i18n.locale !== 'en' ? '/' + this.$i18n.locale : ''
    },
    lang() {
      return this.$i18n.locale
    }
  },
  methods: {
    locateMarket() {
      this.$axios.get('http://ip-api.com/json').then(res => {
        // eslint-disable-next-line no-console
        console.log(res)
        this.$i18n.localePath('index')
      })
    }
  }
}
</script>

<style scoped>
.market span {
  width: 80%;
}
.w-11 {
  width: 2.75rem;
  object-fit: contain;
}
</style>
